import { Helmet } from "react-helmet-async";
import { Box } from "grommet";

// Components
import CarbonGrid from "../../components/CarbonGrid/CarbonGrid";
import CarbonGridToolbar, {
  GridToolbarActionLabels,
  GridToolbarItem
} from "../../components/CarbonGrid/Toolbar/CarbonGridToolbar";
import Authorizer from "../../components/Util/Authorizer";

//  Types & Constants
import { GridType } from "../../types/grid";
import { gridColumns } from "./AuditTrailGridColumns";

import {
  Placeholders,
  UserPermissions,
  GridIDs,
  CarbonIcons
} from "../../constants";

const AuditTrail = (): JSX.Element => {
  // Using pathname for grid id for simple screens with a single grid
  const gridName = GridIDs.AuditTrail;

  const pagePermission = UserPermissions.AuditTrailPerms;

  const actionLabels: GridToolbarActionLabels = {
    singular: "audit trail",
    plural: "audit trails",
    titleSingular: "Audit Trail",
    titlePlural: "Audit Trails"
  };

  const gridSettings: GridType = {
    endpoints: {
      gridODataEndpoint: `/odata/${Placeholders.companyID}/gridaudittrail?$count=true&`
    },
    records: [],
    total: 0,
    data: [],
    lookups: {},
    dataState: {
      pageSize: 25,
      take: 50,
      skip: 0,
      sort: [{ field: "AccessDate", dir: "desc" }]
    },
    dataItemKey: "AuditTrailID",
    singularEntityName: actionLabels.singular,
    pluralEntityName: "records",
    columns: gridColumns,
    showCopyBtn: false,
    showDeleteBtn: false,
    state: {
      editMode: false,
      insertMode: false,
      selectedState: {},
      selectedRow: -1,
      showQuickFilter: false,
      lastSaveDate: null,
      showSavingIndicator: false,
      lockoutMode: false
    }
  };

  const cancelBtn: GridToolbarItem = {
    show: false,
    enable: false,
    tooltip: ""
  };

  const saveBtn: GridToolbarItem = { show: false, enable: false, tooltip: "" };

  const addBtn: GridToolbarItem = { show: false, enable: false, tooltip: "" };

  const editModeBtn: GridToolbarItem = {
    show: false,
    enable: false,
    tooltip: ""
  };

  return (
    <>
      <Helmet>
        <title>Carbon | Audit Trail</title>
      </Helmet>
      <Authorizer
        canView={pagePermission}
        auditLabel={`${actionLabels.titleSingular} screen`}
      >
        <Box align="start" fill>
          <CarbonGridToolbar
            gridId={gridName}
            screenIcon={CarbonIcons.AuditTrail}
            screenTitle={actionLabels.titleSingular}
            permissions={pagePermission}
            actionLabels={actionLabels}
            cancelBtn={cancelBtn}
            saveBtn={saveBtn}
            addBtn={addBtn}
            editModeBtn={editModeBtn}
          />
          <Box fill className="carbon-grid-wrapper">
            <CarbonGrid gridId={gridName} gridSettings={gridSettings} />
          </Box>
        </Box>
      </Authorizer>
    </>
  );
};

export default AuditTrail;
